import { Component } from "react";
import { B, PD } from "../theme";

/* Catches a screen that failed to load or render, so the rest of the app
   (tab bar, settings) stays usable. A new resetKey (the screen) gets a fresh
   try. */

export class LoadBoundary extends Component {
  state = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromProps(props, state) {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null;
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(err) {
    console.error(err);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24 }}>
        <p style={{ ...B, fontSize: 15, color: PD.text, margin: 0, textAlign: "center" }}>This part didn't load.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ ...B, fontSize: 14, color: PD.text, background: PD.bgCard, borderWidth: 1, borderStyle: "solid", borderColor: PD.border, borderRadius: 12, padding: "12px 24px", minHeight: 44, cursor: "pointer" }}
        >
          Reload
        </button>
      </div>
    );
  }
}
